import { combineReducers } from '@reduxjs/toolkit'

import { accessReducer } from './features/access/model/accessSlice'
import { commonCatalogReducer } from './features/catalog/model/commonCatalogSlice'
import { catalogLinksReducer } from './features/catalog-links/model/catalogLinksSlice'
import { scanSessionReducer } from './features/scan-session/model/scanSessionSlice'

/** Состояние модуля `platform`: только намерения фич, без ответов сервера и без секретов. */
export const platformUiReducer = combineReducers({
  access: accessReducer,
  catalogLinks: catalogLinksReducer,
  commonCatalog: commonCatalogReducer,
  scanSession: scanSessionReducer,
})

export type PlatformUiState = ReturnType<typeof platformUiReducer>
